/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import { useMemo } from 'react';

import { useAuth } from '../context/AuthContext';
import {
  formatDateTimeForDisplay,
  fromDateTimeLocalValue,
  resolveDateTimePreferences,
  toDateTimeLocalValue,
} from '../utils/datetime';

export function useAiDateTimeFormatting() {
  const { user } = useAuth();

  const preferences = useMemo(
    () => resolveDateTimePreferences({ timezone: user?.timezone, locale: user?.locale }),
    [user?.timezone, user?.locale]
  );

  return {
    timezone: preferences.timezone,
    locale: preferences.locale,
    formatDateTime: (value: Date | string | number | null | undefined, options?: Intl.DateTimeFormatOptions, fallback?: string) =>
      formatDateTimeForDisplay(value, preferences, options, fallback),
    toDateTimeLocalValue: (value: Date | string | number | null | undefined) =>
      toDateTimeLocalValue(value, preferences),
    fromDateTimeLocalValue: (value: string | null | undefined) =>
      fromDateTimeLocalValue(value, preferences),
  };
}